
// * ========================================================================
// * Responsive chart
// * ========================================================================

const responsiveChart = (function(){
    /**
     * Update chart options
     *
     * @param {Object} chart - chart instance
     * @param {Array} options - chart responsive options
     */
    function update(chart, options = []) {
        let update = false;
        let isMobile = window.innerWidth < 768 ? true : false;

        // Maintain aspect ratio on mobile but dont in desktop
        /*if (options.includes('aspectRatio')) {
            const aspectRatio = isMobile ? true : false;

            // Update value only if needed
            if (aspectRatio !== chart.options.maintainAspectRatio) {
                chart.options.maintainAspectRatio = aspectRatio;
                update = true;
            }
        }*/

        // Show legends on desktop & hide on mobile
        if (options.includes('legend')) {
            const showLegend = isMobile ? false : true;
            if (showLegend !== chart.options.plugins.legend.display) {
                chart.options.plugins.legend.display = showLegend;
                update = true;
            }
        }

        const events = isMobile ? ['click', 'mouseout'] : ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'];
        if (events.length !== chart.options.events.length) {
            chart.options.events = events;
            update = true;
        }

        // Set annotation line width
        /*if (options.includes('annotation')) {
            const borderWidth = isMobile ? 1 : 1;
            if (typeof chart.options.annotation !== 'undefined' && typeof chart.options.annotation.annotations !== 'undefined') {
                for (let i = 0; i <= chart.options.annotation.annotations.length - 1; i++) {
                    if (borderWidth !== chart.options.annotation.annotations[i].borderWidth) {
                        chart.options.annotation.annotations[i].borderWidth = borderWidth;
                        update = true;
                    }
                }
            }
        }*/

        if (update) {
            chart.update();
        }
    }

    return {
        update: update
    }

})();

export default responsiveChart;
